import { Route, Routes } from "react-router-dom";
import AppThemeTestA from "./AppThemeTest/AppThemeTestA";
import AppThemeTestB from "./AppThemeTest/AppThemeTestB";

export default function LandingRoot() {
  const APP_THEME_TEST_PREFIX = 'theme'
  return (
    <Routes>
      <Route path={`${APP_THEME_TEST_PREFIX}/basic`} element={<AppThemeTestA/>}/>
      <Route path={`${APP_THEME_TEST_PREFIX}/brain`} element={<AppThemeTestB/>}/>
    </Routes>
  )
}
